import { render, staticRenderFns } from "./my-core-team-list.html?vue&type=template&id=4560ecd9&scoped=true&external"
import script from "./my-core-team-list.js?vue&type=script&lang=js&external"
export * from "./my-core-team-list.js?vue&type=script&lang=js&external"
import style0 from "./my-core-team-list.scss?vue&type=style&index=0&id=4560ecd9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560ecd9",
  null
  
)

export default component.exports